const Tracks = [
  {
    track_id: "699149461",
    track_color: "241a25",
  },
  {
    track_id: "363701675",
    track_color: "171917",
  },
  {
    track_id: "335989441",
    track_color: "4ea7d8",
  },
  {
    track_id: "21785896",
    track_color: "898a86",
  },
  {
    track_id: "222827567",
    track_color: "562134",
  },
  {
    track_id: "200727838",
    track_color: "5f5854",
  },
  {
    track_id: "342466739",
    track_color: "3c343c",
  },
  {
    track_id: "272199662",
    track_color: "c07c58",
  },
  {
    track_id: "265650922",
    track_color: "392b33",
  },
  {
    track_id: "209666160",
    track_color: "343434",
  },
  {
    track_id: "328961893",
    track_color: "242424",
  },
  {
    track_id: "347485106",
    track_color: "8c443c",
  },
  {
    track_id: "324152280",
    track_color: "8c755d",
  },
  {
    track_id: "342004747",
    track_color: "b494a4",
  },
];
export default Tracks;
